const CATEGORY = {
  SET_CATEGORY_QUERY: 'SET_CATEGORY_QUERY',
  SET_CHILD_CATEGORY_QUERY: 'SET_CHILD_CATEGORY_QUERY',
};

export default CATEGORY;
